import React, { useState } from 'react';
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from '../components/Modal';  // Importer le composant Modal

const Diva = () => {
  const images = [
    'affichediva.jpg', 'diva1.jpg', 'diva2.jpg', 'diva3.jpg', 'diva8.jpg', 'diva9.jpg',
    'diva10.jpg', 'diva14.jpg', 'diva15.jpg', 'diva16.jpg',
    'diva17.jpg', 'diva18.jpg', 'diva19.jpg', 'diva20.jpg', 'diva21.jpg',
    'diva22.jpg', 'diva23.jpg', 'diva24.jpg', 'diva25.jpg', 'diva26.jpg',
    'diva27.jpg', 'diva28.jpg', 'diva29.jpg', 'diva30.jpg', 'diva31.jpg',
    'diva32.jpg', 'diva38.jpg', 'diva39.jpg', 'diva40.jpg', 'diva41.jpg',
    'diva42.jpg', 'diva43.jpg', 'diva44.jpg', 'diva45.jpg', 'diva46.jpg',
    'diva47.jpg', 'diva48.jpg', 'diva56.jpg', 'diva57.jpg', 'diva58.jpg',
    'diva59.jpg', 'diva60.jpg', 'diva61.jpg', 'diva62.jpg', 'diva63.jpg',
    'diva64.jpg', 'diva84.jpg', 'diva85.jpg', 'diva86.jpg', 'diva87.jpg',
    'diva88.jpg', 'diva89.jpg', 'diva90.jpg', 'diva91.jpg', 'diva92.jpg',
    'diva96.jpg', 'diva97.jpg', 
  ];

  const [modalImage, setModalImage] = useState(null);
  const [modalAltText, setModalAltText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const imagesPerPage = 6; // Nombre d'images à afficher par page

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const currentImages = images.slice(
    (currentPage - 1) * imagesPerPage,
    currentPage * imagesPerPage
  );

  return (
    <div className="album-detail">
      <h1>Album Diva du sofa</h1>
      <div className="image-gallery">
        {currentImages.map((image, index) => (
          <img
            key={index}
            src={`/album/diva/${image}`} // Chemin correct pour les images
            alt={`Détail de l'image ${(currentPage - 1) * imagesPerPage + index + 1}`}
            className="album-image"
            loading="lazy"
            onClick={() => openModal(`/album/diva/${image}`, `Détail de l'image ${(currentPage - 1) * imagesPerPage + index + 1}`)}
          />
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Précédent
        </button>
        <span>Page {currentPage}</span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === Math.ceil(images.length / imagesPerPage)}
        >
          Suivant
        </button>
      </div>

      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Diva;
